export default class NavigationHover {
    constructor() {
        this.navItems = document.querySelectorAll('.js-navbar-fixed .js-desktop-navigation nav > ul > li ');

        this.init = this.init.bind(this);
        this.removeLink = this.removeLink.bind(this);
        this.modifyMenuItems = this.modifyMenuItems.bind(this);
        this.modifyShopItems = this.modifyShopItems.bind(this);
        this.stripActiveClass = this.stripActiveClass.bind(this);
        this.addClickEvent = this.addClickEvent.bind(this);

        this.init();
    }

    init() {
        this.navItems.forEach(item => {
            const linkNode = item.querySelector(':scope > div > a');
            if (!linkNode) return;
            const url = linkNode.getAttribute('href');

            const link = linkNode.cloneNode(true);

            if (!link) {
                return;
            }

            if (url && url.includes('/product-category/mattresses/')) {
                this.modifyShopItems(item.querySelector(':scope > div > div'));
            } else {
                this.modifyMenuItems(item.querySelector(':scope > div > div'), link.href, link.textContent);
            }

            this.removeLink(item);
            this.addClickEvent(item);
            this.gatherRangeItems(item.querySelector(':scope > div > div'));
        });
    }

    removeLink(item) {
        const a = item.querySelector(':scope > div > a');
        if (a) {
            a.removeAttribute('href');
            a.style.cursor = 'pointer';
        }
    }

    modifyMenuItems(item, url, text) {
        const firstLink = item.querySelector('ul > a');
        if (!firstLink) return;

        const clone = firstLink.cloneNode(true);

        clone.textContent = text;
        clone.href = url;

        firstLink.insertAdjacentElement('beforebegin', clone);
    }

    checkForNextSibling(item) {
        if (!item.parentElement) return false;
        if (!item.parentElement.previousElementSibling) return false;
        if (!item.parentElement.previousElementSibling.querySelector('ul')) return false;
        return true;
    }

    gatherRangeItems(item) {
        const rangeList = Array.from(item.querySelectorAll('a[href="/"]')).filter(f => f.textContent.toLowerCase().includes('range'));
        if (rangeList.length === 0) return [];

        const rangeItem = rangeList[0];

        if (!rangeItem) return;

        let li = rangeItem.nextElementSibling;
        if (!li) li = rangeItem.parentElement.nextElementSibling;
        if (!li) return;

        const rangeLinks = [rangeItem];

        // Get the next siblings starting from the chosen li
        let currentLi = li;

        // Iterate through the next siblings until there are none
        while (currentLi) {
            rangeLinks.push(currentLi); // Add the current li to the array
            currentLi = currentLi.nextElementSibling; // Move to the next li
        }

        let anchor = rangeItem.closest('ul.flex');
        if (!anchor) {
            console.warn('No Anchor found');
            return;
        }

        anchor = anchor.querySelector(':scope > li:last-child');
        if (!anchor) return;

        const newList = document.createElement('li');
        const ul = document.createElement('ul');

        rangeLinks.forEach(link => {
            ul.insertAdjacentElement('beforeend', link);
        });

        newList.insertAdjacentElement('beforeend', ul);

        anchor.insertAdjacentElement('beforebegin', newList);
    }

    modifyShopItems(item) {
        const mattresses = item.querySelector('a.text-2xl[href*="/product-category/mattresses/"]');
        if (mattresses) {
            mattresses.textContent = '';
            mattresses.style.display = 'flex';
            mattresses.style.alignItems = 'center';
            mattresses.insertAdjacentHTML(
                'beforeend',
                `
                <span class="text-2xl">Shop All Mattresses</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" style="margin-left:8px; height:20px; fill:#252525">
                    <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/>
                </svg>
            `
            );
        }

        const subHeadings = item.querySelectorAll('a.pointer-events-none');

        subHeadings.forEach(subHeading => {
            subHeading.textContent = 'Shop ' + subHeading.textContent.toLowerCase();
            if (subHeading.classList.contains('font-secondary')) {
                if (this.checkForNextSibling(subHeading)) subHeading.parentElement.previousElementSibling.querySelector('ul').insertAdjacentElement('beforeend', subHeading.parentElement);
                subHeading.classList.remove('font-secondary');
                subHeading.classList.remove('text-2xl');
                subHeading.classList.add('font-bold');
                subHeading.classList.remove('pb-4');
                subHeading.classList.add('py-1');
            }

            if (!subHeading.textContent.includes(':')) {
                subHeading.textContent = subHeading.textContent.trim() + ':';
            }
        });
    }

    stripActiveClass() {
        document.querySelectorAll('.js-desktop-navigation .js-active-navigation-item').forEach(item => {
            item.classList.remove('js-active-navigation-item');
        });
    }

    addClickEvent(item) {
        const link = item.querySelector(':scope > div > a');
        if (!link) return;

        link.addEventListener('click', e => {
            const toOpen = item.querySelector(':scope > div > div');
            if (!toOpen) return;

            if (e.target.closest('.js-active-navigation-item')) return;

            this.stripActiveClass();

            toOpen.classList.add('js-active-navigation-item');
        });

        document.querySelector('body').addEventListener('click', e => {
            if (!e.target.closest('.js-navbar-fixed') && !e.target.matches('.js-navbar-fixed')) {
                this.stripActiveClass();
            }
        });
    }
}

new NavigationHover();
